import { Routes, RouteName } from '@/router/routes'
import {
  Users,
  Building2,
  SquarePlus,
  Settings,
  Microscope,
  Rss,
  BarChart3,
  ClipboardList,
  Palette,
  Cpu,
  Database,
  Gauge,
  BarChart4,
  TrendingUp,
  Link2
} from 'lucide-vue-next'
import type { Component } from 'vue'
import type { TNKeys } from '@/components/lang/langHandler'

export interface AdminNavigationItem {
  title: string
  route: RouteName
  icon: Component
  description: string
  labelKey: TNKeys
}

export const salesNavigationItems: AdminNavigationItem[] = [
  {
    title: 'Sales Dashboard',
    route: Routes.ADMIN_DASHBOARD,
    icon: TrendingUp,
    description: 'Sales funnel, churn analysis, and subscription events',
    labelKey: 'salesDashboard'
  },
  {
    title: 'Create Organisation',
    route: Routes.ADMIN_ORGANISATION_CREATE,
    icon: SquarePlus,
    description: 'Create a new organisation',
    labelKey: 'createOrganisation'
  },
  {
    title: 'Users',
    route: Routes.ADMIN_USERS,
    icon: Users,
    description: 'Manage users and permissions',
    labelKey: 'userManagement'
  },
  {
    title: 'Organisations',
    route: Routes.ADMIN_ORGANISATIONS,
    icon: Building2,
    description: 'Manage organisations and settings',
    labelKey: 'orgaManagement'
  },
  {
    title: 'Customizations',
    route: Routes.ADMIN_CUSTOMIZATIONS,
    icon: Settings,
    description: 'Manage organisation customizations',
    labelKey: 'customizations'
  },
  {
    title: 'Affiliates',
    route: Routes.ADMIN_AFFILIATES,
    icon: Link2,
    description: 'Manage affiliate codes and track referrals',
    labelKey: 'affiliates'
  }
]

export const adminNavigationItems: AdminNavigationItem[] = [
  ...salesNavigationItems,
  {
    title: 'Scopes',
    route: Routes.ADMIN_SCOPES,
    icon: Microscope,
    description: 'Manage user scopes',
    labelKey: 'scopes'
  },
  {
    title: 'Live Content Sources',
    route: Routes.ADMIN_LIVE_CONTENT_SOURCES,
    icon: Rss,
    description: 'Manage live content sources and feeds',
    labelKey: 'liveContentSources'
  },
  {
    title: 'Statistics',
    route: Routes.ADMIN_STATISTICS,
    icon: BarChart3,
    description: 'View usage statistics and analytics',
    labelKey: 'statistics'
  },
  {
    title: 'Feature TPrompts',
    route: Routes.ADMIN_TPROMPTS,
    icon: Cpu,
    description: 'Manage runtime feature TPrompts by feature key and scope',
    labelKey: 'models'
  },
  {
    title: 'Model Catalog',
    route: Routes.ADMIN_MODEL_CATALOG,
    icon: Database,
    description: 'View provider-discovered model catalog from /api/model',
    labelKey: 'model'
  },
  {
    title: 'Onboarding Flows',
    route: Routes.ADMIN_ONBOARDING_FLOWS,
    icon: ClipboardList,
    description: 'Manage onboarding questionnaire flows',
    labelKey: 'onboardingFlows'
  },
  {
    title: 'Onboarding Questionnaires',
    route: Routes.ADMIN_USER_STYLES,
    icon: Palette,
    description: 'View generated user styles from onboarding',
    labelKey: 'userStyles'
  },
  {
    title: 'Usage Manager',
    route: Routes.ADMIN_USAGE_MANAGER,
    icon: Gauge,
    description: 'Browse org and user usage, configure restrictions',
    labelKey: 'usageManager'
  },
  {
    title: 'Research Chat Analytics',
    route: Routes.ADMIN_RESEARCH_CHAT_ANALYTICS,
    icon: BarChart4,
    description: 'View research chat usage statistics and trends',
    labelKey: 'researchChatStatistics'
  }
]
